<template>
  <LayoutMinimal>
    <section id="payment_result">
      <div class="content">
        <div class="title">
          <h3>
            <template v-if="loading || error">
              {{ $t("payment_result.title") }}
            </template>
            <template v-else>
              <template v-if="payment.is_preapproval">
                {{ $t("subscription_result.title") }}
              </template>
              <template v-else>
                {{ $t("payment_result.title") }}
              </template>
            </template>
          </h3>
        </div>
        <template v-if="loading || error">
          <div class="loading-or-error">
            <Spinner v-if="loading" />
            <p v-if="error">
              {{ $t("error") }}
            </p>
          </div>
        </template>
        <template v-else>
          <PaymentStatus :payment="payment" />
        </template>
        <div class="buttons">
          <template v-if="$auth.ready() && $auth.user().membership_active">
            <router-link class="btn main-btn" :to="{ name: 'home' }">
              {{ $t("back_to_home") }}
            </router-link>
          </template>
          <template v-else-if="claimsFailedCard">
            <!-- see status -->
          </template>
          <template v-else-if="$auth.check()">
            <router-link class="btn main-btn" :to="{ name: 'dashboard' }">
              {{ $t("header.dashboard") }}
            </router-link>
          </template>
        </div>
      </div>
    </section>
    <template slot="after">
      <Footer />
    </template>
  </LayoutMinimal>
</template>

<script>
import Spinner from "../../components/Spinner";
import Footer from "../../components/Footer";
import LayoutMinimal from "../../layouts/LayoutMinimal";
import resources from "../../resources";
import PaymentStatus from "../../components/PaymentStatus";

export default {
  components: {
    PaymentStatus,
    Spinner,
    LayoutMinimal,
    Footer,
  },
  data() {
    return {
      loading: true,
      error: false,
      payment: null,
      intervalLoadPayment: null,
    };
  },
  computed: {
    claimsSuccess() {
      return this.$route.query.success === "1";
    },
    claimsFailedCard() {
      return (
        this.payment &&
        (this.payment.status === "canceled" ||
          this.payment.status === "failed") &&
        this.payment.data
      );
    },
  },
  methods: {
    loadPayment(id, loginToken) {
      this.error = false;
      this.loading = true;
      this.payment = null;

      resources.payments
        .get({
          id,
          include: ["user_credit_card"],
          login_token: loginToken,
        })
        .then((payment) => {
          this.payment = payment.data.data;
          this.loading = false;

          if (this.claimsSuccess) {
            this.payment.status = "approved";
          }
        })
        .catch(() => {
          this.loading = false;
          this.error = true;
        });
    },
  },
  watch: {},
  beforeRouteUpdate(to, from, next) {
    this.loadPayment(to.params.id);

    next();
  },
  mounted() {
    const paymentId = this.$route.params.paymentId;
    const loginToken = this.$route.query.login_token;

    // TODO: DO NOT REDIRECT TO LOGIN IF THE USER IS ALREADY EXISTS AND NOT LOGGED IN,
    // SHOW THE PAYMENT STATUS
    if (this.$auth.check() || loginToken) {
      this.loadPayment(paymentId, loginToken);
    } else {
      this.$router.push({
        name: "login",
        query: {
          payment_id: this.$route.params.paymentId,
          // datos random solo para molestar
          oq: this.$route.query.success || 0,
          ei: "k68SY4AsrMjWxA_ZkpTIDw",
          uact: 5,
          gs_lcp:
            "Cgdnd3Mtd2l6EAMyBQghEKABMgUIIRCgATIICCEQHhAWEB0yCAghEB4QFhAdMggIIRAeEBYQHTIICCEQHhAWEB0yCAghEB4QFhAdMggIIRAeEBYQH",
          gs_lct:
            "ToKCAAQRxDWBBCwAzoGCAAQHhAWSgQIQRgASgQIRhgAUJUeWMEuYMswaANwAXgAgAGHAYgBjwWSAQM1LjKYAQCgAQHIAQjAAQE",
          // solo este es verdadero
          sc: this.$route.query.success || 0,
          ved: "0ahUKEwjAwbP8vff5AhUspJUCHVkJBfkQ4dUDCA4",
          sclient: "gws-wiz",
        },
      });
    }

    // si viene de ccbill => hago que revice el estado del pago
    // le meto un timeout por si el pago ya viene aprobado y no sea necesario revisar el pago
    let ccbillTimeout = 3000;
    let ccbillIntervalTime = 5000;

    setTimeout(() => {
      this.intervalLoadPayment = setInterval(() => {
        // console.log(this.payment.status);
        !this.claimsSuccess && this.payment && this.payment.status === "pending"
          ? this.loadPayment(paymentId, loginToken)
          : clearInterval(this.intervalLoadPayment);
      }, ccbillIntervalTime);
    }, ccbillTimeout);
  },
  beforeDestroy() {
    clearInterval(this.intervalLoadPayment);
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/classes";

#payment_result {
  .title {
    text-align: center;

    & > * {
      display: inline-block;
      background-color: var(--pallete_main_color);
      color: #ffffff;
      font-weight: bolder;
      text-transform: uppercase;
      font-size: 1.5em;
      margin: 0;
      margin-bottom: 1em;
      padding: 0.25em;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
    }
  }

  .buttons {
    display: block;
    height: auto;
    margin-top: 3em;
    text-align: center;

    .btn.main-btn {
      @extend %fresh-btn;
      padding: 0.5em;
    }
  }
}
</style>
